import {
  DailyChallengeTowerUser,
  SurvivalRankedUser,
} from '../../components/leaderboards';
import { fetchGet } from '../api/common';
import { RankedUser } from '../common/types';

export const fetchGamesPlayedCount = async () =>
  await fetchGet(`/games/total-played-count`);

export const fetchRankings = async () => {
  const rankings: RankedUser[] = await fetchGet(`/rankings/all/20`);
  return rankings
    .filter((r) => r.rankedRating !== -1)
    .sort((a, b) => b.rankedRating - a.rankedRating)
    .slice(0, 20);
};

export const fetchChallengeTowerRankings = async (limit?: number) => {
  const apiUrl = '/rankings/survival/challenge/daily';
  const withLimit = limit ? `?limit=${limit}` : '';
  const rankings: DailyChallengeTowerUser[] = await fetchGet(
    apiUrl + withLimit
  );
  return rankings.sort((a, b) => b.questionsSurvived - a.questionsSurvived);
};

export const fetchChallengeTowerRankingsPreviousWinners = async () => {
  const winners: DailyChallengeTowerUser[] = await fetchGet(
    '/rankings/survival/challenge/daily/previous-winners'
  );
  return winners;
};
